$.fn.barslide = function( options ) {
 	
 	var defaults = { 
 			complete : function() {},
 			start : function() {},
 			step : function() {}
 	};

 	var settings = $.extend( {}, defaults, options );

    return this.each(function(i, barel) {
		var bar = $(barel);
		bar.width(0);
		bar.show();

		if(bar.data('from-color')) {
			bar.css({'background-color' : bar.data('from-color')});
		}


		var effect = bar.data('effect') ? bar.data('effect') : 'linear';
		var animation = { width: bar.data('end-width') + bar.data('width-unit') };

		if(bar.data('to-color')) {
			animation.backgroundColor = bar.data('to-color');
		}

		bar.velocity( animation, { 
			duration : parseFloat(bar.data('duration')), 
			easing : effect,
			complete : function() {
				settings.complete.call($(this));
			},
			start : function() {
				settings.start.call($(this));
			},
			step : function() {
				settings.step.call($(this));
			}
		});
		var round = bar.data('round-at') ? bar.data('round-at') : 1;

		bar.find('.nm').velocity({ 'tween' : [parseFloat(bar.data('end-num')), parseFloat(bar.data('start-num')) ] }, {
			duration: parseFloat(bar.data('duration')),
			easing:false,
			progress: function(elements, complete, remaining, start, tweenValue) {
				var number = Math.round(tweenValue * round) / round;
				bar.find('.nm').text(number.toString().replace('.',','));
			}
		});
	});
};